// @core/api/endpoints/landing/get_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingPageResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Get landing page by ID
 * Retrieves a landing page with all sections and settings.
 */
export async function GetLandingPage(
  page_id: string,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.get<LandingPageResponse>(requestPath, { ...requestOptions });
}
